import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import { Row, Text } from 'Components/UI/_Legacy'

import map from 'lodash/map'

import AQ from './aq'
import { Arrow, Container, Header, StyledCollapse } from './styles'

function Category({ category }) {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggleOpen = useCallback(() => setIsOpen(!isOpen), [isOpen])

  return (
    <Container className={`${isOpen && 'opened'}`}>
      <Header opened={isOpen ? 1 : 0} onClick={handleToggleOpen}>
        <Text as="h2" letterSpace={0.5} medium>
          {category?.title}
        </Text>

        <Arrow opened={isOpen ? 1 : 0} />
      </Header>

      <StyledCollapse isOpen={isOpen}>
        {map(category?.content, entity => (
          <Row key={entity.id}>
            <AQ aq={entity} key={entity?.id} />
          </Row>
        ))}
      </StyledCollapse>
    </Container>
  )
}

Category.defaultProps = {
  category: {},
}

Category.propTypes = {
  category: PropTypes.object,
}

export default Category
